module.exports = __webpack_public_path__ + "static/img/tw.8a194685.svg";